import React, { Component, Fragment } from 'react';
import {
  Col, Row, Button, Form, FormGroup, Label, Input, FormText
} from 'reactstrap';
import Select from 'react-select';
import TimePicker from 'rc-time-picker';
import moment from 'moment';

import 'react-select/dist/react-select.css';
import 'rc-time-picker/assets/index.css';

import statesList from 'constants/AmericanStates';
import { validate } from 'utils/formvalidate';
import SingleDatePickerWrapper from './SingleDatePickerWrapper';
import SoonoEventApi from '../../apis/SoonoEvent';
import Toaster from '../Toaster';

const InputFieldRenderer = ({
  label, name, inputField, type, placeholder, handleChange, handleBlur, required, ...restProps
}) => {
  const { value, error } = inputField;

  return (
    <Fragment>
      <Label for={name}>{label}</Label>
      <Input
        {...restProps}
        type={type}
        name={name}
        id={name}
        value={value}
        placeholder={placeholder}
        onChange={handleChange}
        onBlur={handleBlur}
        required={required}
      />
      {required && (<div className="error">{error}</div>)}
    </Fragment>
  );
}

export default class SocialForm extends Component {
  constructor() {
    super();
    this.state = {
      name: {},
      date: {
        value: moment()
      },
      time: {
        value: moment()
      },
      address_line_1: {},
      address_line_2: {},
      city: {},
      state: {},
      zip: {},
      contact_person: {},
      email: {},
      phone_number: {},
      additional_information: {}
    }
  }

  handleSelectChange = (select) => {
    const value = select ? select.value : null;

    this.setState({
      state: {
        error: null,
        value
      }
    })
  };

  handleChange = (e) => {
    const { name, value, required } = e.target;
    let error = null;
    if (required)
      error = validate(name, value);
    this.setState({
      [name]: {
        ...this.state[name],
        error,
        value
      }
    });
  };

  onTimeChange = (time) => {
    const value = time;
    let error = '';

    if (!value)
      error = 'This field is required';
    this.setState({
      time: {
        value,
        error
      },
    })
  }

  onDateChange = (date) => {
    let error = ''
    if (!date)
      error = 'This field is required';
    this.setState({ date: { value: date, error } });
  }

  handleBlur = (e) => {
    const { name, value, required } = e.target;
    let error = null;

    if (required)
      error = validate(name, value.trim());
    this.setState({
      [name]: {
        ...this.state[name],
        error,
        value: value.trim()
      }
    });
  }

  validateForm = () => {
    const notRequiredFields = ['address_line_2', 'phone_number', 'additional_information'];
    const formFields = Object.keys(this.state);
    const _state = {};
    let valid = true;
    formFields.map(fieldName => {
      const fieldData = this.state[fieldName];
      const error = validate(fieldName, fieldData.value);
      if (!notRequiredFields.includes(fieldName))
        valid = !error && valid;
      _state[fieldName] = { ...fieldData, error };
    });
    this.setState({ ..._state });
    return valid;
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const {
      name,
      date,
      time,
      address_line_1,
      address_line_2,
      city,
      state,
      zip,
      contact_person,
      email,
      phone_number,
      additional_information
    } = this.state;

    const bookData = {
      name: name.value,
      date: date.value,
      time: time.value,
      address_line_1: address_line_1.value,
      address_line_2: address_line_2.value,
      city: city.value,
      state: state.value,
      zip: zip.value,
      contact_person: contact_person.value,
      email: email.value,
      phone_number: phone_number.value,
      additional_information: additional_information.value
    }

    if (this.validateForm()) {
      SoonoEventApi.book(bookData).then(data => {
        Toaster.getSuccessToaster('check-circle', 'Event booked successfully');
      }).catch(err => {
        Toaster.getErrorToaster('exclamation-triangle', 'Something went wrong')
      })
    }
  }

  render() {
    const {
      name,
      date,
      time,
      address_line_1,
      address_line_2,
      city,
      state,
      zip,
      contact_person,
      email,
      phone_number,
      additional_information
    } = this.state;

    return (
      <form className="form" onSubmit={this.handleSubmit} noValidate>
        <FormGroup>
          <InputFieldRenderer
            label="Event Name"
            placeholder="Event name"
            type="text"
            name="name"
            inputField={name}
            handleChange={this.handleChange}
            handleBlur={this.handleBlur}
            required
          />
        </FormGroup>
        <Row form className="mb-5">
          <Col md={6}>
            <FormGroup>
              <Label>Event Date</Label>
              <div>
                <SingleDatePickerWrapper
                  className="form-control"
                  onDateChange={this.onDateChange}
                  date={date.value}
                />
              </div>
              <div className="error">{date.error}</div>
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label for='time' >Event Time</Label>
              <TimePicker
                showSecond={false}
                value={time.value}
                className="form-control"
                id="time"
                name="time"
                onChange={this.onTimeChange}
                format={'hh:mm a'}
                clearIcon={false}
                use12Hours
                inputReadOnly
              />
              <div className="error">{time.error}</div>
            </FormGroup>
          </Col>
        </Row>

        <Row form>
          <Col md={6}>
            <FormGroup>
              <InputFieldRenderer
                label="Address 1"
                placeholder="Address 1"
                type="text"
                name="address_line_1"
                inputField={address_line_1}
                handleChange={this.handleChange}
                handleBlur={this.handleBlur}
                required
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <InputFieldRenderer
                label="Address 2"
                placeholder="Address 2"
                type="text"
                name="address_line_2"
                inputField={address_line_2}
                handleChange={this.handleChange}
                handleBlur={this.handleBlur}
              />
            </FormGroup>
          </Col>
        </Row>

        <Row form className="mb-5">
          <Col md={5}>
            <InputFieldRenderer
              label="City"
              placeholder="City"
              type="text"
              name="city"
              inputField={city}
              handleChange={this.handleChange}
              handleBlur={this.handleBlur}
              required
            />
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label>State</Label>
              <Select
                options={statesList}
                onChange={this.handleSelectChange}
                onBlur={() => { }}
                value={state.value}
                removeSelected
              />
              <div className="error">{state.error}</div>
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <InputFieldRenderer
                label="Zip"
                placeholder="Zip code"
                type="text"
                name="zip"
                inputField={zip}
                handleChange={this.handleChange}
                handleBlur={this.handleBlur}
                required
              />
            </FormGroup>
          </Col>
        </Row>
        <FormGroup>
          <InputFieldRenderer
            label="Contact Name"
            placeholder="Name"
            type="text"
            name="contact_person"
            inputField={contact_person}
            handleChange={this.handleChange}
            handleBlur={this.handleBlur}
            required
          />
        </FormGroup>
        <Row className="mb-5">
          <Col md={6}>
            <FormGroup>
              <InputFieldRenderer
                label="Email"
                placeholder="Email"
                type="email"
                name="email"
                inputField={email}
                handleChange={this.handleChange}
                handleBlur={this.handleBlur}
                required
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <InputFieldRenderer
                label="Phone Number"
                placeholder="Phone"
                type="text"
                name="phone_number"
                inputField={phone_number}
                handleChange={this.handleChange}
                handleBlur={this.handleBlur}
              />
            </FormGroup>
          </Col>
        </Row>
        <FormGroup>
          <InputFieldRenderer
            label="Additional Info"
            placeholder="Short Description on Event"
            type="textarea"
            rows={4}
            name="additional_information"
            inputField={additional_information}
            handleChange={this.handleChange}
            handleBlur={this.handleBlur}
          />
        </FormGroup>
        <Button className="btn-warning text-white mt-3">Book event</Button>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SoonoSocial/Form.js